import React, { Fragment, useState } from 'react'
import { Table, Modal, Card, Button } from 'react-bootstrap'
import { formato_monto } from '../../common/Formatos'
import { FaSearch, FaUserTie, FaBuilding } from 'react-icons/fa'


const CustomTable = ({ data, handleInforme, movimiento, isPEC, showAbogadoObs }) => {

    const [tituloModal, setTituloModal] = useState('')
    const [comentario, setComentario] = useState('Sin comentarios.')
    const [comentarioVisado, setComentarioVisado] = useState('Sin comentarios.')
    const [showModal, setShowModal] = useState(false)

    const [showObsModal, setShowObsModal] = useState(false)
    const [obsModalTitulo, setObsModalTitulo] = useState('')
    const [obsModalContent, setObsModalContent] = useState('')

    const abrirObsCobertura = (titulo, contenido) => {
        setObsModalTitulo(titulo)
        setObsModalContent(contenido || '<Sin Observaciones>')
        setShowObsModal(true)
    }

    if (!data || data.length === 0) {
        return <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
    }

    const coberturas = Array.from(
        new Map(
            data.flatMap(d => d.coberturas?.map(c => [c.codigo, c]) ?? [])
        ).values()
    )

    const totalPorImplicado = (imp) =>
        imp.coberturas?.reduce((sum, c) => sum + (Number(c.monto) || 0), 0) || 0

    const totalPorCobertura = (codigo) =>
        data.reduce(
            (sum, imp) => sum + (Number(imp.coberturas?.find(c => c.codigo === codigo)?.monto) || 0),
            0
        )

    const totalGeneral = data.reduce((sum, imp) => sum + totalPorImplicado(imp), 0)

    const ultimaFechaImplicado = (imp) => {
        const fechas = imp.coberturas?.map(c => c.ultFechaRegistro).filter(f => !!f)
        if (!fechas || fechas.length === 0) return '-'
        return fechas.sort(
            (a, b) =>
                new Date(a.split('-').reverse().join('-')) -
                new Date(b.split('-').reverse().join('-'))
        )[fechas.length - 1]
    }

    const abrirObservaciones = (imp) => {
        setComentario(imp?.comentario || '<Sin Observaciones>')
        setComentarioVisado(imp?.comentaVisado || '<Sin Observaciones>')
        setTituloModal(movimiento + ' - ' + imp.nombre)
        setShowModal(true)
    }

    return (
        <Fragment>
            <Table striped bordered className="customTable">
                <thead>
                    <tr>
                        <th style={{ minWidth: '200px' }}>Cobertura</th>
                        {data.map(imp => (
                            <th key={imp.rut} style={{ textAlign: 'center' }}>
                                {imp.nombre}
                            </th>
                        ))}
                        <th style={{ textAlign: 'center' }}>Total Cobertura</th>
                    </tr>
                </thead>
                <tbody>
                    {coberturas.map(cob => (
                        <tr key={cob.codigo}>
                            <td><b>{cob.nombre}</b></td>
                            {data.map(imp => {
                                const found = imp.coberturas?.find(x => x.codigo === cob.codigo)
                                return (
                                    <td key={imp.rut + cob.codigo} style={{ textAlign: 'right' }}>
                                        {formato_monto(found?.monto || 0)}
                                        {(isPEC || showAbogadoObs) && (
                                            <span style={{ marginLeft: '6px', whiteSpace: 'nowrap' }}>
                                                <FaUserTie
                                                    size={13}
                                                    color={found?.obsResponsable ? '#28a745' : '#ccc'}
                                                    title={found?.obsResponsable ? 'Obs. Abogado' : 'Sin observación del abogado'}
                                                    style={{ cursor: found?.obsResponsable ? 'pointer' : 'default', marginLeft: '3px' }}
                                                    onClick={found?.obsResponsable ? () => abrirObsCobertura('Obs. Abogado — ' + cob.nombre, found.obsResponsable) : undefined}
                                                />
                                                {isPEC && (
                                                    <FaBuilding
                                                        size={13}
                                                        color={found?.obsAnalistaCIA ? '#17a2b8' : '#ccc'}
                                                        title={found?.obsAnalistaCIA ? 'Obs. CIA' : 'Sin observación CIA'}
                                                        style={{ cursor: found?.obsAnalistaCIA ? 'pointer' : 'default', marginLeft: '3px' }}
                                                        onClick={found?.obsAnalistaCIA ? () => abrirObsCobertura('Obs. CIA — ' + cob.nombre, found.obsAnalistaCIA) : undefined}
                                                    />
                                                )}
                                            </span>
                                        )}
                                    </td>
                                )
                            })}
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                {formato_monto(totalPorCobertura(cob.codigo))}
                            </td>
                        </tr>
                    ))}

                    <tr>
                        <td style={{ fontWeight: 'bold' }}>TOTAL IMPLICADO</td>
                        {data.map(imp => (
                            <td key={'total-' + imp.rut} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                {formato_monto(totalPorImplicado(imp))}
                            </td>
                        ))}
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                            {formato_monto(totalGeneral)}
                        </td>
                    </tr>

                    <tr className="table-light">
                        <td style={{ fontWeight: 'bold' }}>Último Registro</td>
                        {data.map(imp => (
                            <td
                                key={'fecha-' + imp.rut}
                                style={{ textAlign: 'right', cursor: 'pointer', color: '#007bff' }}
                                onClick={() => abrirObservaciones(imp)}
                            >
                                {ultimaFechaImplicado(imp)}
                                {imp.idfolioCargaDocto > 0 &&
                                    <FaSearch
                                        color='gray'
                                        size={16}
                                        title="Ver Documento"
                                        style={{ cursor: 'pointer', marginLeft: '6px' }}
                                        onClick={(e) => { e.stopPropagation(); handleInforme(imp); }}
                                    />
                                }
                            </td>
                        ))}
                        <td>-</td>
                    </tr>
                </tbody>
            </Table>

            <Modal show={showObsModal} onHide={() => setShowObsModal(false)} size='md' centered>
                <Modal.Header style={{ backgroundColor: '#4F517A', color: 'white' }} closeButton>
                    <Modal.Title style={{ fontSize: '16px' }}>{obsModalTitulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ whiteSpace: 'pre-wrap', fontSize: '14px', marginBottom: 0 }}>{obsModalContent}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='outline-secondary' onClick={() => setShowObsModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Observaciones - {tituloModal}
                    </Card.Header>
                    <Card.Body>
                        <h5 className="card-title">Responsable Gestión:</h5>
                        {comentario}
                        <br /><br />
                        <h5 className="card-title">Analista Compañía:</h5>
                        {comentarioVisado}
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                    .customTable > thead {
                        color: white;
                        background-color: rgb(114, 139, 176);
                        font-size: 14px
                    }
                    .customTable > thead > tr > th {
                        padding: 8px 10px;
                        font-size: 14px;
                        font-weight: 500;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default CustomTable
